module.exports = __webpack_public_path__ + "img/40_38_067_930.c9af0f94.jpg";